module.exports = __webpack_public_path__ + "static/media/android-sms-icon.9f230872.png";